var map = {
	"./actravel/hotelOn.png": "./src/assets/images/sites/actravel/hotelOn.png",
	"./aero/hotelOn.png": "./src/assets/images/sites/aero/hotelOn.png",
	"./chasma/hotelOn.png": "./src/assets/images/sites/chasma/hotelOn.png",
	"./consolid/hotelOn.png": "./src/assets/images/sites/consolid/hotelOn.png",
	"./consolidarargentina/hotelOn.png": "./src/assets/images/sites/consolidarargentina/hotelOn.png",
	"./delfos ar/hotelOn.png": "./src/assets/images/sites/delfos ar/hotelOn.png",
	"./delfos latam paraguay/hotelOn.png": "./src/assets/images/sites/delfos latam paraguay/hotelOn.png",
	"./demoreg/hotelOn.png": "./src/assets/images/sites/demoreg/hotelOn.png",
	"./freewayonline/hotelOn.png": "./src/assets/images/sites/freewayonline/hotelOn.png",
	"./fyatour/hotelOn.png": "./src/assets/images/sites/fyatour/hotelOn.png",
	"./gotravelres/hotelOn.png": "./src/assets/images/sites/gotravelres/hotelOn.png",
	"./gotrenes/hotelOn.png": "./src/assets/images/sites/gotrenes/hotelOn.png",
	"./grupoocho/hotelOn.png": "./src/assets/images/sites/grupoocho/hotelOn.png",
	"./juantoselliinternationaltours/hotelOn.png": "./src/assets/images/sites/juantoselliinternationaltours/hotelOn.png",
	"./logan/hotelOn.png": "./src/assets/images/sites/logan/hotelOn.png",
	"./lozadaviajes/hotelOn.png": "./src/assets/images/sites/lozadaviajes/hotelOn.png",
	"./pezzativiajes/hotelOn.png": "./src/assets/images/sites/pezzativiajes/hotelOn.png",
	"./piamonte/hotelOn.png": "./src/assets/images/sites/piamonte/hotelOn.png",
	"./sevens/hotelOn.png": "./src/assets/images/sites/sevens/hotelOn.png",
	"./tamesys/hotelOn.png": "./src/assets/images/sites/tamesys/hotelOn.png",
	"./thetravelstore/hotelOn.png": "./src/assets/images/sites/thetravelstore/hotelOn.png",
	"./trayectouno/hotelOn.png": "./src/assets/images/sites/trayectouno/hotelOn.png",
	"./ttoperadora/hotelOn.png": "./src/assets/images/sites/ttoperadora/hotelOn.png",
	"./turivel/hotelOn.png": "./src/assets/images/sites/turivel/hotelOn.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/sites sync recursive ^\\.\\/.*\\/hotelOn\\.png$";